// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__B7wVn","article":"index_article__KY95g","articlecontent":"index_articlecontent__Dp1_q","graph":"index_graph__IDhAa","point":"index_point__mvU6d"};